export default {
  // Actions:
  add: "Toevoegen",
  cancel: "Annuleren",
  delete: "Verwijderen",
  edit: "Bewerk",
  exit: "Uitgang",
  filter: "Filter",
  import: "Import",
  goBack: "Ga terug",
  logout: "uitloggen",
  next: "Volgend",
  previous: "Voorgaand",
  return: "Terugkeer",
  save: "Besparen",
  search: "Zoeken",
  signIn: "Aanmelden / Inschrijven",
  sortBy: "Sorteren op",
  upload: "upload",
  validate: "Bevestigen",
  yes: "Ja",
  No: "Nee",
  others: "Andere",

  //days of week
  monday: "maandag",
  tuesday: "dinsdag",
  wednesday: "woensdag",
  thursday: "donderdag",
  friday: "vrijdag",
  day: "dag",

  // Messages:
  // [Info]
  contentModelDescription:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation",
  dragMessage:
    "Sleep een bestand hiernaartoe of klik om het te downloaden bestand te selecteren.",
  dropMessage: "[glisser-déposer pour changer l’ordre des onglets]",
  importInProgress: "- Bezig met importeren van saldo. Een ogenblik geduld ...",
  importTimeSheet: "Import van schalen van de organisatie",
  noCollaboratorsMatches: "",
  notifUpdates: "Meldingen van updates",
  nothingFound: "niets gevonden",
  nothingToShow: "Niets om te laten zien",
  noBudget: "Er wordt geen budget geïmporteerd voor deze organisatie.",
  noTimeSheet: "Geen saldo is geïmporteerd voor deze organisatie.",
  noTimeSheetMatches:
    "Geen enkele urenstaat komt overeen met uw filterwaarden!",
  noFinancialSheetMatches: "Er komen geen resultaten overeen met uw filter.",
  noOrganization: "Huidige organisatie is niet geactiveerd.",
  searchNameorVATNumber: "Zoek op naam of BTW-nummer",
  defaultDialogMessage: "Wil je doorgaan?",
  typesNoCategories: "Niet-gecategoriseerde servicetypen",
  selectCategoriesMessage:
    "Maak de selectie ongedaan om categorieën uit te sluiten.",
  searchMessageCategories:
    "Tik op een categorie om deze aan uw selectie toe te wijzen",
  searchMessageValuations:
    "Tik op een waardering om deze aan uw selectie toe te wijzen",
  chooseMessageCategories:
    "Selectie van categorieën voor classificatie van categorieën",
  attentionArrivalDate:
    "[The statistics are calculated from the employee's arrival date]",
  attentionDepartureDate:
    "[The statistics are calculated to the employee's departure date]",
  attentionWorkingDates:
    "[The statistics are calculated from the employee's arrival date to hir deparute one]",
  NoAffected: "ONAANGETAST",
  validatePreviousLevels: "[validate first two levels to unlock this one]",

  // [Confirmation]
  confirmationCategoriesTitle: "Bevestiging van toekenning",
  confirmationCategoriesMessage:
    "Wilt u de categorie aan uw selectie toewijzen?",
  deleteCategoriesTitle: "Dissociatie bevestiging",
  deleteCategoriesMessage: "Weet je zeker dat je deze man wilt ontkoppelen?",
  confirmationDeleteCategoryMessage:
    "Weet je zeker dat je deze categorie wilt verwijderen?",
  confirmationDeleteSuperCategoryMessage:
    "Weet je zeker dat je deze supercategorie wilt verwijderen?",
  confirmationDeleteAnalysisPlanMessage:
    "Weet u zeker dat u dit scanplan wilt verwijderen?",
  confirmationDeleteValuationMessage:
    "Weet u zeker dat u deze classificatie wilt verwijderen ?",
  confirmationDeleteCategoryTitle: "Bevestiging van verwijdering",
  confirmationOverwriteTitle: "[Confirmation de surcharge]",
  confirmationForcedDeleteCategoryMessage: "Wil je de verwijdering forceren?",
  confirmationForceDeleteCategoryTitle: "Fout verwijderen",
  confirmationForceUpdateCategoryTitle: "[Update error]",
  confirmationForcedUpdateCategoryMessage:
    "[Are you sure you want to overwrite the billablity of associeted task-type ?]",
  // [Confirmation]
  confirmationDeleteRoleTitle: "Bevestiging van verwijdering",
  confirmationDeleteRoleMessage: "[Do you want to remove the role?]",
  confirmationDeleteZoneTitle: "[Confirmation of deletion]",
  confirmationDeleteZoneMessage: "[Do you want to remove the zone?]",
  confirmationDeleteBuTitle: "[Confirmation of deletion]",
  confirmationDeleteBuMessage: "[Do you want to remove the BU?]",
  confirmationDeleteRegimeTitle: "Bevestiging van verwijdering",
  confirmationDeleteRegimeMessage: "[Do you want to remove the regime?]",
  confirmationDeleteHolidayTypeTitle: "[Confirmation of deletion]",
  confirmationDeleteHolidayTypeMessage:
    "[Do you want to remove this type of holiday?]",
  confirmDeleteTasksMessage:
    "Sommige services die tot het datumbereik van het te importeren bestand behoren, zijn al opgeslagen. Wilt u deze overschrijven?",
  confirmationOverWriteCategoriesMessage:
    "[Do you want to over-write the distribution of actual total?]",

  // [Success]
  importSuccess: "Import succesvol",
  importTimeSheetSuccess: "urenstaat importeren succesvol",
  operationCompleted: "Actie uitgevoerd met succes",
  successfulAction: "Succesvolle actie",
  correlateTaskTypeSuccess: "correlatie geslaagd",

  // [Error]
  error: "Fout",
  errorOccured: "Er is een fout opgetreden, Gelieve te proberen later.",
  incorrectFile: "Geïmporteerd bestand is niet compatibel !",
  incompatibleModel:
    "Het geïmporteerde bestand komt niet overeen met het gekozen model !",
  fileSize:
    "[The size of imported file is not supported, please export a file with maximum 800 lines!]",
  incompleteOperation:
    "Kan de operatie niet voltooien, onjuiste gegevens zijn ingediend",
  lostMessage: "Je bent zo snel gegaan en bent verdwaald...",
  noResult: "Oeps, Er zijn geen resultaten gevonden voor uw zoekopdracht",
  Oops: "Oeps",
  pageNotFound: "Zou deze pagina kan niet gevonden!",
  collaboratorNotArrivedYet:
    "[the collaborator was not recruited at the selected analyse date]",
  collaboratorHasLeft:
    "[the collaborator has left the organization by the selected analyse date]",
  collaboratorNeedConfiguration:
    "[the collaborator need configuration before getting statistics]",

  // Label
  chooseERP: "Kies de ERP",
  communities: "Gemeenschappen",
  capacityPlaning: "[Capacity planing]",
  dateRange: "datumbereik",
  endDate: "Einddatum",
  profile: "Profiel",
  settings: "instellingen",
  startDate: "begin datum",
  diagram: "[Schéma]",
  cycleLabel: "[Schéma du tableau]",
  TAMTAMApplications: "TAMTAM-toepassingen",
  manageTasks: "[Manage tasks]",
  categories: "Categorieën",
  noCategory: "Buiten categorie",
  noValuation: "Buiten classificatie",
  allCategories: "Alle categorieën",
  clientGroup: "klantengroep",
  client: "cliënt",
  collaboratorList: "lijst met medewerkers",
  collaboratorSpace: "Werknemersruimte",
  collaborator: "medewerker",
  collaborators: "medewerkers",
  taskCategory: "taakcategorie",
  periodeType: "Soort periode",
  datePeriod: "periode datum",
  attribution: "Naamsvermelding",
  timeAchieved: "Bereikte tijd",
  statistics: "statistieken",
  allClients: "Alle bestanden",
  myClients: "Mijn bestanden",
  otherClients: "De andere bestanden",
  collaboratorsSettings: "collaborators setting",
  categorySettings: "[category settings]",
  name: "Naam",
  regime: "[Regime]",
  role: "[Role]",
  grade: "anciënniteitsniveau",
  to: "au",
  recentActivities: "recente activiteiten",
  noActivities: "geen activiteiten",
  relizedDuration: "gerealiseerde tijd",
  folder: "Dossier",
  annualCapacity: "[Annual capacity]",
  NFHr: "[Non billable Hours]",
  regimes: "[Regimes]",
  basicNFH: "[NF basique]",
  specialProject: "[NF special project]",
  nbrWeeks: "[Nombre de semaine]",
  RHHebdo: "RH Hebdo",
  total: "[Total]",
  solde: "[Credit]",
  configBudget: "[manage Budget]",
  arrivalDate: "[arrival date]",
  departureDate: "[departure date]",
  selectDate: "[select a date]",
  selectZone: "[select a zone]",
  selectBu: "[select a bu]",
  selectRole: "[select a role]",
  selectRegime: "[select a regime]",
  selectProfile: "[select a profile]",
  enterSpecialProject: "[entre special project]",
  asClientManager: "[as client manager]",
  asSupervisor: "[as supervisor]",
  asEncodingDelegate: "[as encoding delegate]",
  removeSuccess: "[Remove success]",
  saveSuccess: "[Save success]",
  rolesList: "[Role list]",
  typesList: "[Type list]",
  zonesList: "[Zone list]",
  busList: "[BU list]",
  createRole: "[Create role]",
  createType: "[Create type]",
  updateRole: "[Update role]",
  updateType: "[Update type]",
  updateZone: "[Create zone]",
  createZone: "[Update zone]",
  updateBu: "[Create BU]",
  createBu: "[Update BU]",
  roleCreated: "[Role created]",
  zoneCreated: "[Zone created]",
  buCreated: "[Business unit created]",
  roleUpdated: "[Role updated]",
  holidayTypeUpdated: "[Holiday type updated]",
  zoneUpdated: "[Zone updated]",
  buUpdated: "[Business unit updated]",
  roleDeleted: "[Role deleted]",
  holidayTypeDeleted: "[Holiday type deleted]",
  zoneDeleted: "[Zone deleted]",
  buDeleted: "[Business unit deleted]",
  regimesList: "[Regime list]",
  createRegime: "[Create regime]",
  updateRegime: "[Update regime]",
  regimeCreated: "[Regime created]",
  regimeUpdated: "[Regime updated]",
  regimeDeleted: "[Regime deleted]",
  collaboratorUpdated: "[collaborator updated]",
  setBudgetGlobal: "[enter the total budget]",
  title: "[Title]",
  budgeted: "[Budgeted]",
  nonBudgeted: "[Non-budgeted]",
  remainingBudget: "Nog toe te wijzen budget",
  dossierCount: "[Client count]",
  hrForWeek: "[Hours per week]",
  hrForYear: "[Hours per year]",
  AssociatedWith: "Geassocieerd met",
  classified: "geclassificeerd",
  BelongsTo: "Hoort bij",
  usualBillable: "[expected billable]",
  billable: "[Real billable]",
  usualNonBillable: "[Allowed non-billable]",
  nonBillable: "[Real non-billable]",
  nonBillableAdmittedQP: "[NBA prorata]",
  annualAffectedBudgetQP: "[AAB prorata]",
  realAffectedBudgetQP: "[real budget prorata]",
  analyseDate: "[Analyse date]",
  spreadPositive: "[Spread+]",
  spreadNegative: "[Spread-]",
  involvement: "[involvement]",
  clearing: "[Clearing]",
  shortfall: "[Shortfall]",
  shortage: "[Shortage",
  diffNonBillable: "[Difference non-billable]",
  localisation: "[localization]",
  businessUnit: "[Business unit]",
  zones: "[Zones]",
  zone: "[Zone]",
  bu: "[BU]",
  squad: "ploeg",
  baseOn: "[base on]",
  clonerFrom: "[clone from]",
  forYear: "[for the year]",
  cloneSuccess: "[clone successfull]",
  budgetCloned: "[Budget cloned]",
  selectRegimeMessage: "Selecteer een regime ",
  desactivateDelegation: "[Deactivate the delegation and reset the budget]",
  activateDelegation: "[Activate the delegation]",
  addNewDelegated: "[add new delegated collaborator]",
  topfolders: "Topmappen",
  flopfolders: "Flopmappen",
  topprogressions: "Topprogressies",
  flopprogressions: "flop progressies",
  effectiveBenchmark: "effectieve benchmark",
  normalizedBenchmark: "gestandaardiseerd benchmark",

  //Comments
  overloadCollaborator: "[An overload hours for this employee of %xh]",
  clientOutBudget:
    "[With an intervention on %x files other than those budgeted]",
  overloadNonBillable: "[A non-billable overtime of %xh is recorded]",
  almostNonBillable:
    "[The non-billable pro rata account may be settled, there is %xh remaining]",
  greatProgressARC:
    "[A very interesting engagement with %x more hours compared to the annual budget prorata]",
  acceptedProgressARC:
    "[A remarkable commitment with a negligible delay of %x hours compared to the annual budget prorata]",
  warningProgressARC:
    "[A worrying engagement with a delay of %x hours compared to the annual budget prorata]",
  alertProgressARC:
    "[Almost no engagement with a delay of %x hours compared to the annual budget prorata]",
  greatProgressCRC:
    "[A very interesting engagement with %x more hours compared to the annual capacity prorata]",
  acceptedProgressCRC:
    "[A remarkable commitment with a negligible delay of %x hours compared to the annual capacity prorata]",
  warningProgressCRC:
    "[A worrying engagement with a delay of %x hours compared to the annual capacity prorata]",
  alertProgressCRC:
    "Almost no engagement with a delay of %x hours compared to the annual capacity prorata",
  overNinety: "[coefficient over 90%]",
  underNinety: "[coefficient under 90%]",
  releasedOverUsualBillable: "[Released billable exceed the usual]",
  releasedUnderUsualBillable: "[Released billable doesn't cover the usual]",
  notifyUsingUa:
    "Waarschuwing: deze link is niet langer functioneel. Gelieve in te loggen via deze link: ",
  // Titles
  Caution: "Voorzichtigheid",
  budget: "begroting",
  clientList: "[liste des clients]",
  productionCapacityPlanning: "[Production capacity planing]",
  detailedBudget: "Gedetailleerd budget van :",
  toDate: "tot op heden",
  MyTimeSheet: "Urenstaat",
  taskTypesSettings: "Beheer taken",
  subTitleCapacityPlanningProduction: "[VUE CAPACITY PLANING GÉNÉRALE]",
  subTitleClientList: "[visualize and manage your customer files]",
  subTitleTimeSheet: "GEDETAILLEERD FINANCIEEL GEZONDHEIDSZICHT",
  subTitleBudgetSheet:
    "GEDETAILLEERDE GEZONDHEIDSZICHTVUE ETAT DU SITUATION BUDGETAIRE",
  subTitleCategoryStatistics: "Incenderat autem audaces usque ad insaniam",
  titleModalRegime: "[Create or edit regimes]",
  titleModalHolidayType: "[Create or edit types of holidays]",
  titleModalRole: "[Create or edit roles]",
  titleModalLocalization: "[Create or edit localizations params]",
  UpdateCollaboratorSettingTitle: "[Collaborator's settings]",
  UpdateCollaboratorSetting: "[Manage collaborator's settings]",
  ProfilCollaboratorSetting: "[Collaborator's profil]",
  KPIEvaluation: "[KPI Evaluation]",
  KPIBudgetaire: "[KPI Budgetary]",
  manageBudget: "[Manage the budget :]",
  manageBudgetClient: "[Manage budget dossier]",
  budgetSettingOf: "[Budget configuration for]: ",
  budgetSetting: "[Budget setting]",
  remainingHours: "[Remaining hours]",
  realizedHours: "[Realized Hours]",
  extraTimeSuccess: "[extraTimeSuccess]",
  extraTimeWarning: "[extraTimeWarning]",
  extraTimeDanger: "[extraTimeDanger]",
  affectedBudget: "[Affected budget]",
  realizedBudget: "[Realized budget]",
  extraBudget: "[Extra-Budeget]",
  nonBillableHours: "[Non-billable]",
  billableHours: "[billable]",

  // Enumeration
  ACTIVATED: "GEACTIVEERD",
  DEACTIVATED: "UITGESCHAKELD",
  READY: "[PRÊT]",
  PENDING: "In afwachting",
  NOT_CONFIGURED: "[NON CONFIGURÉ]",

  CLIENT_GROUP: "[Groupe de client]",
  CLIENT: "[Client]",
  TASK_TYPE: "[Type de prestation]",
  COLLABORATOR: "[Collaborateur]",

  french: "Frans",
  english: "Engels",
  dutch: "Nederlands",

  today: "Vandaag",
  yesterday: "Gisteren",
  otherday: "Eergisteren",
  week: "Week",

  monthly: "Maandelijks",
  current: "Actueel",
  annual: "Jaarlijks",

  CapacityAnnual: "[Capacity annual]",
  NonBillableAdmitted: "[Non billable admitted]",
  AnnualAffectedBudget: "[Annual affected budget]",
  OutBudgetCompletion: "[Completion off budget]",
  BudgetaryAvailability: "[Budgetary availability]",
  CapacityAnnualQP: "[State of capacity annual]",
  NonBillableSaved: "[State of non billable saved]",
  AnnualReleasedCompletion: "[Annual released completion]",
  CurrentReleasedCompletion: "[Current released completion]",
  BillableCoefficient: "[Current billable coefficient]",
  BillableNFCoefficient: "[NF coefficient]",

  month: "maand",
  quarter: "kwartaal",
  semester: "semester",
  year: "jaar",
  attachedClients: "Bijgevoegde klanten",
  addCategories: "Voeg vos-categorieën toe",
  manageCategories: "Categorieën beheren",
  categoriesList: "Categorieën lijst",
  tasksList: "[Tasks list]",
  assignCategorie: "[Assign tasks to categories]",
  categoryUpdated: "Categorie bijgewerkt",
  ValuationUpdated: "Bijgewerkte classificatie",
  categoryAdded: "Categorie toegevoegd",
  ValuationAdded: "classificatie toegevoegd",
  categoryDeleted: "Categorie verwijderd",
  ValuationDeleted: "classificatie verwijderd",
  frenchTitle: "Franse Titel",
  coefficient: "Coëfficiënt",
  englishTitle: "Engelse Titel",
  dutchTitle: "Nederlandse titel",
  addCategory: "Voeg een categorie",
  addAnalysisPlan: "Voeg een analysis plan",
  addSuperCategory: "Voeg een geweldige categorie toe",
  typeTitleCategory: "Typ de titel van uw categorie (3 talen beschikbaar)",
  typeTitleAnalysisPlan:
    "Typ de titel van uw analysis plan (3 talen beschikbaar)",
  typeTitleSuperCategory:
    "Typ de titel van uw supercategorie in (3 talen beschikbaar)",
  typeTitleValuation:
    "Typ de titel van uw beoordeling in (3 talen beschikbaar) ",
  classification: "Classificatie",
  selectCommunity: "kies uw community",
  listCommunity: "Lijst van ledencommunitys",
  CommunityUnauthorised:
    "Deze community heeft geen toegang tot deze applicatie",

  CLIENT_MANAGER: "Bestandsbeheer",
  ENCODING_DELEGATE: "Afgevaardigde coderen",
  RESPONSIBLE: "[Responsible]",
  DELEGATED: "[Delegated]",
  myFolders: "Bestanden als verantwoordelijke",
  otherFolders: "Bestanden als gemachtigde",
  tableView: "gecodeerde weergave",
  graphicView: "grafische weergave",
  Categories: "Categorieën",
  SuperCategories: "Super Categorieën",
  AnalysesPlan: "Analyseplan",
  SuperCategory: "Super Categorie...",
  AnalysisPlan: "Analyseplan...",
  Untreated: "Onbehandeld",
  Little_treated: "Weinig behandeld",
  All: "Alle",
  Normal: "Normaal",
  Overtaking: "Inhalen",
  WorkingHoursPerDay: "Werktijden per dag",
  NumberOfDays: "Aantal dagen",
  OvertakingHours: "Let op, je hebt een inhalen van: ",
  TimeLeft: "Aantal resterende uren om toe te wijzen: ",

  collaboratorNotLinkedToAnyZone: "Medewerker niet gekoppeld aan een zone",
  pleaseAssignHimAZoneBeforeSettingUpHisCalendar:
    "Wijs hem een zone toe voordat u zijn agenda instelt.",
  pleaseConfigureTheCompanysAnnualCalendarBefore:
    "Configureer eerst de jaarkalender van het bedrijf.",
  AnnualCalendarNotFound: "Jaarkalender niet gevonden.",
  calendarSettings: "Kalender beheer",
  holidays: "Vakantie",
  annualHolidays: "Jaarlijkse vakantie",
  workingDays: "Werkdagen",
  paidVacations: "Betaalde vakanties",
  paidVacation: "Betaalde vakantie",
  myVacations: "Mijn vakanties",
  ManageTheCollaboratorsCalendar: "Beheer de kalender van de medewerker.",
  ManageMyCalendar: "Beheer mijn agenda en mijn vakanties.",
  ManageTheAnnualCalendarOfYourFiduciary:
    "Beheer de jaarkalender van uw fiduciaire",
  confirmationDeleteCalendarConfigMessage:
    "Weet u zeker dat u deze configuratie wilt verwijderen?",
  ManageTheCollaboratorsInformation: "Beheer werknemersinformatie",
  FinancialStatement: "Financieel overzicht",
  subTitleFinancialSheet: "GEDETAILLEERD OVERZICHT VAN FINANCIËLE GEZONDHEID",

  myCalendar: "Mijn Kalender",
  noAnnualCalendar: "de jaarkalender voor het jaar",
  annualCalendarNotConfig: "is nog niet geconfigureerd",

  importedFrom: "geïmporteerd uit",
  identifier: "identifier",

  selectCollaborator: "selecteer ten minste één medewerker",

  entiteFiltre: "Entiteit (klanten geassocieerd met: )",
  analysis: "Analyse",
  details: "Details",
  entite: "Entiteit",

  clientType: "Type klanten",
  attache: "Gehecht",
  tous: "Alle",
  entiteType: "Entiteit",

  configureClassesMessage: "Configureer a.u.b. de toegevoegde waarde klassen",
  analysisRealisedHours: "Analyse van uitgevoerde uren op toegevoegde waarde :",
  MoreDetails: "Meer details",

  descriptionAnnualFolder: `Deze tabel geeft hier de budgetten en de gerealiseerde bedragen op jaarbasis weer`,
  descriptionCurrentFolder: `Deze tabel geeft hier de budgetten weer en wordt proportioneel uitgevoerd, dat wil zeggen rekening houdend met een budget<br/>gelijkmatig verdeeld over het jaar en de huidige synchronisatiedatum`,

  realized: "Realiseerde",

  profit: "Winst",
  budgetaryBenchmark: "Budgettaire benchmark",
  benchmark: "Effectieve benchmark ",
  sum: "Som",
  Belgique: "België",
  Maroc: "Marokko",
  effectiveRate: "Effectief tarief",
  budgetaryRate: "Budgettair tarief",
  and: "en",
  more: "andere klanten ",
  globalBudgetLeft: "Globaal budget over",
  surpassedBudget: "Je hebt het globale budget overschreden",
  overwrittenZoneBudget: "U loopt het risico het zonebudget te overschrijven",
  insufficientZoneBudget: "Onvoldoende zonebudget",
  insufficientGlobalBudget: "Onvoldoende globaal budget",
  dataDelegatedCollaboratorRequired:
    "Gedelegeerde gegevens van een medewerker zijn vereist",

  ADMIN: "Beheerder",
  USER: "Gebruiker",
  NONE: "Geen",
  EDITOR: "Uitgever",
  LEGAL_REPRESENTATIVE: "Wettelijke vertegenwoordiger",
  OFFICIAL: "medewerker",
  EXTERNAL: "Extern",
  MANAGER: "Manager",
  roles: "rollen",
  "Accounting roles": "Accounting rollen",
  "Organization roles": "Organisatierollen",
  "Apply authorization to selected users":
    "Toestemming toepassen op geselecteerde gebruikers",
  Apply: "Toepassen",
  "New user": "Nieuwe gebruiker",
  "Select All": "Selecteer alles",
  "Deselect All": "Deselecteer alles",
  Preferences: "Voorkeuren",
  "associate privileges": "geassocieerde privileges",
  clientsPrivileges: "dashboardrechten",
  accessClientList: "Geef toegang tot de klantenlijst",
  allowConfigurateBudget: "[Allow budget configuration]",
  activateNotifications: "[activateNotification]",
  activateCalendarNotifications: "[activateCalendarNotifications]",
  activateCarteNotifications: "[activateCarteNotifications]",
  allowAccessClientSpace: "[]",
  allowAccessCollaboratorList: "[Allow access to collaborator liste]",
  "Allow associate dashboards": "Dashboard-koppeling toestaan",
  Processing: "Verwerken",
  "Successfully updated": "Succesvol geüpdatet",
  authorizations: "autorisaties",
  users: "gebruikers",
  user: "Gebruiker",
  editor: "Uitgever",
  admin: "Beheerder",
  manager: "Manager",
  partner: "Partner",

  myCollaboratorSpace: "Mijn medewerker ruimte",

  applicationNotActivated:
    "Power Team-applicatie is niet Geactiveerd voor de huidige organisatie.",
  accountingNotActivated:
    "Accounting applicatie is niet Geactiveerd voor de huidige organisatie.",
  applicationNotActivatedIndication:
    "Voor meer informatie kunt u contact met ons opnemen.",
  about_us_content: `is een geheel van tools die een bepaalde groep toelaat om te communiceren, uitwisselen, organiseren en doeltreffend samenwerken. Het platform bevat verschillende applicaties samengevoegd naargelang de noden van de klant. Dankzij deze tools, beschikken onze klanten over de laatste technologie.`,
  "You don't have the rights for the requested operation":
    "U heeft niet de rechten voor de gevraagde bewerking",
  totalCollaboratorFolderInfo:
    "een medewerker werkt mogelijk aan hetzelfde bestand met verschillende rollen, wat betekent dat het totaal niet altijd gelijk is aan de som van de vier kolommen van de bestanden.",

  budgetGlobal: "Globaal budget",
  affectationBudgetaire: "Toewijzing van de begroting",
  budgetParCat: "Budget per categorie",
  attributionBudgetaire: "Attributie van de begroting",

  globalBudgetAffected: "wereldwijd budget beïnvloed",
  globalBudgetNotAffected: "Budget niet beïnvloed",
  budgetByZoneAffected: "budget per getroffen zone",
  budgetZoneDelegationAffected: "budgetdelegatie getroffen",
  budgetZoneByCategoryNotCompleted: "budget per categorie niet voltooid",
  delegationNotAffected: "delegatie niet beïnvloed",
  budgetCompleted: "budget voltooid",
  update: "Updaten",
  budgetUpdated: "Budget succesvol bijgewerkt.",
  errorUpdatingBudget: "Onbekende fout bij het updaten van het budget.",
  parametersUpdated: "Parameters bijgewerkt",
  parameterSettings: "Parameter beheer",
  parameterSettingsParameterBenchmark:
    "Activeer of deactiveer synchronisatie en beheer de fiduciaire instelling",
  parameterBenchmark: "Beheer de fiduciaire parameter",
  parameterSynchronization: "Synchronisatieparameter",
  parameterOrganization: "fiduciaire instellingen",
  parameterAuth: "Autorisatie parameter",
  managementRolesCollaboratorsOnFiles:
    "Beheer van de rollen van medewerkers op bestanden",
  manageRole: "Beheerrol",
  manageEntity: "Entiteitsbeheer",
  ManageClientEntityRelationships:
    "Beheer van relaties tussen klant en entiteit",
  annualBenchmark: "Jaarlijkse benchmark",
  enterAnnualBenchmark: "Voer de jaarlijkse benchmark in",
  messageInfoSynchronization:
    "Het activeren van synchronisatie houdt in dat het beheer van entiteiten en / of rollen niet langer toegankelijk zal zijn vanuit Power Team, en om wijzigingen aan te brengen moet u via uw ERP gaan.",
  dynamicTable: "Magische Tafel",
  all: "Alle",
  unbudgeted: "Niet gebudgeteered",
  inProgress: "Bezig",
  advanced: "Geavanceerd",
  budgetedState: "Gebudgeteered",
  unknown: "Onbekend",
  SUPERVISOR: "Leidinggevende",
  messageInfoBenchmark:
    "Als u deze parameter niet specificeert, is de standaard gebruikte benchmarkwaarde 70.",
  superviseur: "Leidinggevende",
  StatusBudgEco: "Status economisch budget",
  StatusBudgHoraire: "Uurlijkse budgetstatus",
  budgetEcoManquant: " Niet-toegewezen economisch budget",
  Export: "exporteren",
  Import: "Importeren",
  importFinancialSheet: "Import financieel overzicht",
  importFinancialSheetSuccess:
    "Het importeren van het financiële overzicht is gelukt",
  importFinancialContentModelDescription:
    "Controleer of uw Excel-bestand de volgende kolommen bevat",
  monAgenda: "Mijn agenda",
  myBirthdays: "Mijn verjaardagen",
  noEvent: "Geen evenement",
  calendrier: "Kalender",
  explorer: "verkennen",
  cumulate: "cumuleren",
  cumulated: "cumulated",
  nonCumulated: "not cumulated",
  individual: "individueel",
  collective: "collectief",
  taskTypeUpdated: "taaktype bijwerken",
  isBillable: "factureerbaar",
  individualScore: "[individual score]",
  collectiveScore: "[collectif score]",
  organizationScore: "[score fudiciaire]",
  REJECTED: "Afgekeurd",
  APPROVED: "Goedgekeurd",
  rejectionMessage: "Weet u zeker dat u dit verlof wilt weigeren ?",
  approvalMessage: "Weet u zeker dat u dit verlof wilt goedkeuren ?",
  NonBudgetise: "Deze klant kan niet worden gebudgetteerd !",
  regimeVAT: "btw-regime",
  closingDate: "Sluitingsdatum",
  totalBudget: "Totale budget",
  belgiumBudget: "BE begroting",
  moroccoBudget: "MA Budget",
  SCAN_OP: "SCAN OP",
  deleted: "[deleted]",
  persistent: "[persistent]",
  clientState: "[Client state]",
  selectedRole: "[Selected role]",
  notCollaborator: "Niet langer een medewerker",
  se: "Encoding supervisor",
  folderNumber: "Aantal bestanden",
  collaboratorNumber: "Aantal medewerkers",
  categoryNumber: "Aantal categorieën",
  userNumber: "Aantal gebruikers",
  activate: "Activeren",
  desactivate: "Dectiveren",
  Budgeting: "Budgettering",
  BudgetingInProgress:
    "- Er wordt gewerkt aan de budgettering. Een moment alstublieft ..."
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js